import { ThemeKeyType } from './slice/types';

/* istanbul ignore next line */
export const isSystemDark = window?.matchMedia
  ? window.matchMedia('(prefers-color-scheme: dark)')?.matches
  : undefined;

export function saveTheme(theme: ThemeKeyType) {
  window.localStorage && localStorage.setItem('selectedTheme', theme);
}

/* istanbul ignore next line */
export function getThemeFromStorage(): ThemeKeyType | null {
  return window.localStorage
    ? (localStorage.getItem('selectedTheme') as ThemeKeyType) || null
    : ('light' as ThemeKeyType);
  // return 'light' as ThemeKeyType;
}
export function truncateFileSize(sizeInBytes) {
  const sizeInKB = sizeInBytes / 1024;
  if (sizeInKB >= 1000) {
    const sizeInMB = Math.floor((sizeInKB / 1024) * 100) / 100;
    return sizeInMB + ' MB';
  } else {
    return Math.floor(sizeInKB * 100) / 100 + ' KB';
  }
}
